import React from 'react';
import { observer } from 'mobx-react-lite';
import VipTag from '@/components/agent-limit/vip-tag';

const TipsSuper = observer(({ className, tip = '限免' }) => {

  if (tip === 'vip') {
    return (
      <div
        className={[
          'flex-shrink-0 w-74px h-22px text-12px text-[#FF7307] font-bold vh-center ml-4px rounded-4px',
          className,
        ]}
      >
        <VipTag />
      </div>
    );
  }

  return (
    <div
      className={[
        'flex-shrink-0 w-42px h-18px text-12px text-[#FF7307] font-bold vh-center bg-[#FF73071A] ml-4px rounded-4px',
        className,
      ]}
    >
      {tip}
    </div>
  );
});

export default TipsSuper;
